import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { ShopEditInformationTemplate } from 'components/Templates'
import { useDispatch, useSelector } from 'react-redux'
import { getStoreRef } from 'reducks/auth/selectors'
import { State } from 'index'
import { fetchStore } from 'reducks/store/operations'
import { getIsBeingEdited } from 'reducks/confirm/selectors'
import { updateEditState } from 'reducks/confirm/operations'

const Information: FC = () => {
  const dispatch = useDispatch()
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const isBeingEdited = useSelector((state: State) => getIsBeingEdited(state))

  useEffect(() => {
    if (!storeRef || isBeingEdited) return
    dispatch(fetchStore(storeRef))
    dispatch(updateEditState(true))
  }, [storeRef])

  return (
    <Layout title={'店舗基本情報を編集'}>
      <ShopEditInformationTemplate
        isCreatePage={false}
        isEventPage={false}
        isEditedByOwner={true}
        storeId={storeRef.id}
      />
    </Layout>
  )
}

export default Information
